import React from "react";
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import schema from "./Data/RoleCRUDConfig.json";
import { Box } from "@mui/material";
import PageHeader from "../../components/PageHeader";
import PermissionGrid from "../../components/PermissionGrid";
const RolesPage = () => {
  return (
    <Box sx={{ display: "flex" }}>
       <Box sx={{ flexGrow: 1, marginTop:0, marginLeft: 15,  marginRight: 15, marginBottom:15}} >
      <PageHeader pageTitle="Manage Role" />
      <PermissionGrid/>
        <CrudManager
          data={schema}
          actionBtnName="Add New Role"
          createFormTitle="Add Role"
          updateFormTitle="Update Role"
        />
      </Box>
    </Box>
  );
};

export default RolesPage;
